import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;
  margin-bottom: 40px;

  h3 {
    width: 85%;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 10px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  > p {
    width: 75%;
    font-size: 16px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    > span {
      color: ${props => props.theme.colors.mainColor}
    }
  }

  > span {
    width: 380px;
    margin-bottom: 16px;
    font-size: 14px;
    text-align: center;
    color: ${props => props.theme.colors.grey03};
  }
`

export const Timer = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.mainColor};
  margin-bottom: 4px;
`
